import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import './CurrentTicket.css'; // certifique-se de ter estilos básicos

const CurrentTicket = ({ number, driver, counter }) => (
  <div className="current-ticket">
    <h2>LIBERADO</h2>
    <AnimatePresence mode="wait">
      <motion.div
        key={number + driver}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.5 }}
        className="ticket-info"
      >

        <div className="current-number">CG/NF: {number}</div>
        <div className="current-driver">Nome: {driver}</div>
      </motion.div>
    </AnimatePresence>
  </div>
);

CurrentTicket.propTypes = {
  number: PropTypes.string.isRequired,
  driver: PropTypes.string.isRequired,
  counter: PropTypes.string
};

export default CurrentTicket;
